import { HTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";

const ViewProperty = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => (
  <div
    className={twMerge(
      "flex items-center gap-1.5 text-sm font-medium [&_svg]:text-grey-500 text-grey-700",
      className,
    )}
    {...props}
  />
);

const MobileProperty = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => (
  <div
    className={twMerge(
      "flex items-center gap-1.5 text-sm font-medium border border-grey-200 rounded-full py-1 px-2.5 bg-white",
      className,
    )}
    {...props}
  />
);

const RecordProperties = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={twMerge(
        "flex rounded-xl bg-grey-25 border border-grey-200 shadow-xs flex-col divide-y divide-grey-100",
        className,
      )}
      {...props}
    ></div>
  );
};

const RecordPropertiesGroup = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={twMerge("flex flex-col gap-4 p-4 px-6 py-5 flex-1", className)}
      {...props}
    />
  );
};

const RecordPropertiesGroupTitle = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={twMerge(
        "flex items-center justify-between gap-2 font-medium text-grey-900 relative",
        className,
      )}
      {...props}
    />
  );
};

const RecordPropertiesItem = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div className={twMerge("flex flex-col gap-0.5", className)} {...props} />
  );
};

const RecordPropertiesItemLabel = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={twMerge(
        "font-medium text-sm text-grey-500 flex gap-1.5 items-center",
        className,
      )}
      {...props}
    />
  );
};

const RecordPropertiesItemValue = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={twMerge(
        "flex-1 text-grey-800 flex items-center gap-1.5",
        className,
      )}
      {...props}
    />
  );
};

export {
  RecordProperties,
  RecordPropertiesItem,
  RecordPropertiesItemLabel,
  RecordPropertiesItemValue,
  RecordPropertiesGroup,
  RecordPropertiesGroupTitle,
  MobileProperty,
  ViewProperty,
};
